import { render, staticRenderFns } from "./OverseasChainRevenueReport.vue?vue&type=template&id=19d91f56"
import script from "./OverseasChainRevenueReport.vue?vue&type=script&lang=js"
export * from "./OverseasChainRevenueReport.vue?vue&type=script&lang=js"
import style0 from "./OverseasChainRevenueReport.vue?vue&type=style&index=0&id=19d91f56&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports